enum SortOrderEnum {
    ASC = "asc",
    DESC = "desc",
}

export default SortOrderEnum;
